// extracted by mini-css-extract-plugin
module.exports = {"SubmitButton":"SubmitButton__SubmitButton___1z2EW"};